import { PrimeIcons } from 'primereact/api'
import { FileUpload, FileUploadProps, FileUploadSelectParams } from 'primereact/fileupload'
import { ReactNode, useRef } from 'react'
import styled from 'styled-components'
import UploadIcon from '../../../assets/icons/uploadIcon.svg'
import { Button } from '../Button/Button'

interface IUpload extends FileUploadProps {
  handleSelect: (e: FileUploadSelectParams) => void
  cancelButtonRef?: any
  handleRemove: (callback: any, file: any) => void
  name: string
  error?: string | boolean
  info?: string | ReactNode
}
export const Upload = ({ name, error, handleSelect, handleRemove, cancelButtonRef, info, ...props }: IUpload) => {
  //utils
  const chooseBtnRef = useRef<any>(null)
  //templates
  const uploaderTemplate = (file: any, props: any) => {
    return (
      <div className="mb-2 flex gap-3 align-items-center">
        <Div>
          <p title={file.name}>{file.name.substring(0, 30) + '...'}</p>
        </Div>
        <Button onClick={() => handleRemove(props.onRemove, file)} variant="ghost">
          <i className={PrimeIcons.TRASH} />
        </Button>
      </div>
    )
  }

  const emptyTemplate = () => {
    return (
      <div>
        <Div
          onClick={() => {
            chooseBtnRef.current?.children[0].click()
          }}
          className="cursor-pointer"
        >
          <UploadIcon />
          <p>Click to upload</p>
          <p>or drag and drop</p>
        </Div>
        <div className="helper-text">
          <small>{info}</small>
        </div>
      </div>
    )
  }

  const headerTemplate = (options: any) => {
    const { className, chooseButton, cancelButton } = options

    return (
      <>
        <div ref={chooseBtnRef} className={className}>
          {chooseButton}
        </div>
        {cancelButtonRef && (
          <div ref={cancelButtonRef} className={className}>
            {cancelButton}
          </div>
        )}
      </>
    )
  }
  return (
    <div className="flex flex-column gap-2">
      <FileUpload
        name={name}
        onSelect={handleSelect}
        headerClassName="hidden"
        contentClassName="p-0 border-transparent"
        itemTemplate={uploaderTemplate}
        emptyTemplate={emptyTemplate}
        headerTemplate={headerTemplate}
        {...props}
      />
      {typeof error === 'string' && <small className="p-error block">{error}</small>}
    </div>
  )
}

const Div = styled.div`
  width: 289px;
  height: 104px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.colors.secondary_40};
  border-radius: 8px;

  p:first-of-type {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.secondary_100};
  }

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: ${({ theme }) => theme.colors.black};
  }
`
